export enum EventNames {
    LOAD = 'load',
    DOM_CONTENT_LOADED = 'DOMContentLoaded',
    DRAG_START = 'dragstart',
    DRAG_END = 'dragend',
    DRAG_ENTER = 'dragenter',
    DRAG_LEAVE = 'dragleave',
    DRAG_OVER = 'dragover',
    DROP = 'drop',
    KEYDOWN = 'keydown',
    KEYUP = 'keyup',
    KEYPRESS = 'keypress',
    CLICK = 'click',
    MOUSEDOWN = 'mousedown',
    MOUSEUP = 'mouseup',
    RESIZE = 'resize',
    SCROLL = 'scroll',
    CHANGE = 'change',
    MOUSEOVER = 'mouseover',
    MOUSEOUT = 'mouseout'
}
